class CartRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }

    handleIntersection(entries, observer) {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations();
    }

    loadRecommendations() {
        fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('cart-recommendations');
                const cartRecommendationsList = html.querySelector('.cart-recommendations--list');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                    if (!cartRecommendationsList.innerHTML.trim().length) {
                        this.closest('.cart--recommendations ').classList.add('hidden')
                    }else {
                        this.closest('.cart--recommendations ').classList.remove('hidden')
                    }
                }
                this.renderBundleInfo()

            })
            .catch(e => {
                console.error(e);
            });
    }

    renderBundleInfo() {
        this.querySelectorAll('.m-price').forEach((t => {
            var product_price =parseInt(t.dataset.productPrice);
            var product_type = t.dataset.productType;
            var product_antal = parseInt(t.dataset.productAntal);
            var suffix_unit = 'stk.';
            var is_divide_by_antal = false;
            var label = '';
            var bundle_price = product_price;

            for (var i = 0; i < bundle_constant.length; i++) {
                if (bundle_constant[i].product_type == product_type) {
                  suffix_unit = bundle_constant[i].suffix_unit;
                  if (bundle_constant[i].calc_rule == 'antal') {
                    is_divide_by_antal = true;
                  }
                }
            }

            if (product_antal > 0 && is_divide_by_antal) {
                bundle_price = product_price / product_antal;
                label = formatMoney(bundle_price, window.MinimogSettings.money_format) + ' per ' + suffix_unit;
                t.querySelector('.m-price__sale .bsf-pris-pr-stk').innerHTML = label;
            }
        }))
    }

    updateUrl(productId) {
        if (productId) {
            const { routes } = window.MinimogSettings;
            this.dataset.url = `${routes.product_recommendations_url}?section_id=cart-drawer&product_id=${productId}&limit=8`;
        }
    }
}
customElements.define('cart-recommendations', CartRecommendations);
